module.exports = {
    REQUEST_LIST : "REQUEST_LIST"
    ,FRIEND_LIST:"FRIEND_LIST"
    ,FLASH_LIST:"FLASH_LIST"
    ,FRIEND_UPDATE_ITEM:"FRIEND_UPDATE_ITEM"
    ,FRIEND_QUERY_RESULT:"FRIEND_QUERY_RESULT"
    ,REQUEST_APPLY:"REQUEST_APPLY"
    ,FRIEND_APPLY:"FRIEND_APPLY"
    ,OPEN_FRIEND_INFO:"OPEN_FRIEND_INFO"
    ,OPEN_FRIEND_INFOM:"OPEN_FRIEND_INFOM"
    ,FRIEND_CLEAN_APPLY:"FRIEND_CLEAN_APPLY"
    ,FRIEND_DELETE:"FRIEND_DELETE"
    ,FRIEND_QUERY_FIND:"FRIEND_QUERY_FIND"
    ,FRIEND_ADD:"FRIEND_ADD"
    ,FRIEND_RECOMMEND:"FRIEND_RECOMMEND"
    ,CLOSE_OTHER:"CLOSE_OTHER"
    ,UPDATE_COUNT:"UPDATE_COUNT"
    ,UPDATE_INTIMACY:"UPDATE_INTIMACY"
    ,UD_COMMEND_LIST:"UD_COMMEND_LIST"      //好友推荐列表
    ,ADD_NEW_MSG:"ADD_NEW_MSG"              //新的聊天数据
    ,FriendAddOrDel:"FriendAddOrDel"        //好友数量增加删除
    ,FlowerNum:"FlowerNum"                  //欢迎入宗赠送鲜花
    ,FRIEND_TALK:"FRIEND_TALK"              //好友聊天
    ,FRIEND_MSG_PANEL:"FRIEND_MSG_PANEL"
    ,STRANGER_LIST:"STRANGER_LIST"
    ,UPDATE_ONLINE:"UPDATE_ONLINE"          //刷新陌生联系人在线信息
    ,SELECT_ITEM:"SELECT_ITEM"              //选中联系人
    ,CONTACT_DELETE:"CONTACT_DELETE"        //删除联系人
    ,CONTACT_BLACK:"CONTACT_BLACK"          //黑名单聊天
    ,TEAM_RECOMMAND_SUCCESS:"TEAM_RECOMMAND_SUCCESS"              //退队申请好友成功
    ,Update_Red_Point:"Update_Red_Point"              //更新红点    
    ,Open_Friend_List:"Open_Friend_List"
    ,UPDATE_APPLY:"UPDATE_APPLY"
    ,UPDATE_GROUP_COUNT:"UPDATE_GROUP_COUNT"
    ,UPDATE_BLACK_LIST:"UPDATE_BLACK_LIST"
    ,STRENGTH_UPDATE:"STRENGTH_UPDATE"
    ,UPDATE_APPLY_LIST:"UPDATE_APPLY_LIST"
};